<div
  *ngIf="accountBillingTypePrepaid && contentData"
  class="row"
  [ngClass]="billingPage ? 'summary-panel' : ''"
>
  <div class="col-12 col-md-8 col-lg-8 tertiary-vertical-content">
    <div class="justify-content-md-center">
      <div *ngIf="!isP10MCustomer" class="col-12 col-md-8 col-lg-8 p-l-lg">
        <div class="row m-t-xl clearfix">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-xl">
            <h3 class="amount-label">
              {{
                customerAccountBillingDetails?.availableFunds || 0
                  | currency: 'USD' : 'symbol-narrow'
              }}
            </h3>
            <span class="amount-text">{{ contentData?.availableBalance }}</span>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-xl relative">
            <h3 class="amount-label">
              {{
                customerAccountBillingDetails?.renewalAmount || 0
                  | currency: 'USD' : 'symbol-narrow'
              }}
            </h3>
            <span class="amount-text">{{ contentData?.renewalAmount }}</span>
            <i
              class="fa fa-info-circle m-l-sm renewal-info"
              aria-hidden="true"
              tabindex="0"
              #toolTip
            ></i>
            <div class="renewal-amount-tooltip" [innerHTML]="contentData?.renewalTooltip"></div>
          </div>
        </div>
        <div>
          <p *ngIf="balanceExpirationDate" class="billing-block-margin small m-t-xs">
            Balance Expiration<span class="pull-right">{{ balanceExpirationDate }}</span>
          </p>
          <p *ngIf="balanceExpirationDate" class="billing-block-margin xsmall m-t-xs">
            {{ contentData?.balanceExpirationMessage }}
          </p>
          <p
            *ngIf="customerAccountBillingDetails?.isGoldSubscriber"
            class="billing-block-margin small m-t-sm"
          >
            Gold Rewards<span class="pull-right">{{ isGoldMember }}</span>
          </p>
        </div>
        <ng-container
          *ngIf="isAutopayEnabled && !isSuspendedAccount && !hideAutopay; else notEnabledAutopay"
        >
          <p class="lead m-t-md m-b-lg">
            <span class="autopay-enabled"
              >{{ contentData?.enabledAutopayText1 }} {{ this.autopayRenewal | date }}
              {{ contentData?.enabledAutopayText2 }} {{ autopayCardType }}
              {{ autopayCardNumber }}</span
            >
          </p>
        </ng-container>
        <ng-template #notEnabledAutopay>
          <p
            *ngIf="!isSuspendedAccount && !hideAutopay && !hideRefillCta"
            class="lead m-t-md m-b-lg"
          >
            <a [routerLink]="[billingLandingConstants.AUTOPAY_URL]" class="autopay-not-enabled">
              {{ contentData?.setupAutopay }}
            </a>
          </p>
        </ng-template>
        <div
          class="col-lg-9 renewal-date-info"
          *ngIf="renewalDateText"
          [innerHTML]="renewalDateText"
        ></div>
        <div *ngIf="!hideRefillCta" class="text-start button-spacing">
          <button
            id="add-to-balance"
            class="btn btn-primary"
            [routerLink]="[billingLandingConstants.OTP_URL]"
            [disabled]="isTouristPlan"
          >
            {{ contentData?.addToBalance }}
          </button>
        </div>
      </div>
      <div *ngIf="isP10MCustomer" class="col-12 col-md-7 col-lg-7">
        <div class="m-t-xl clearfix">
          <p class="lead m-t-md">{{ contentData?.welcomeMessage }}</p>
          <p class="small m-t-xs">{{ contentData?.welcomeMessageDescription }}</p>
        </div>
        <div class="text-center button-spacing">
          <button
            id="buy-additional-data"
            class="btn btn-primary"
            (click)="navigate(true)"
            [disabled]="isTouristPlan"
          >
            {{ contentData?.buyAdditionalData }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!hideQuickLinks" class="col-12 col-md-3 col-lg-3 tertiary-buttons-vertical buttons-2">
    <ng-container *ngIf="accountLandingEnhancementsEnabled; else notAccountLandingEnhancements">
      <div class="quick-links-layout">
        <div class="quick-link-block">
          <a [routerLink]="['/my-profile']"
            ><i class="quick-link-icon my-profile-icon"></i><span>{{ contentData?.myProfile }}</span
            ><i class="fa fa-fw fa-angle-right"></i
          ></a>
        </div>
        <div class="quick-link-block">
          <a [routerLink]="[billingLandingConstants.BILLING_LANDING_URL]"
            ><i class="quick-link-icon payment-history-icon"></i
            ><span>{{ contentData?.paymentHistory }}</span
            ><i class="fa fa-fw fa-angle-right"></i
          ></a>
        </div>
        <div class="quick-link-block" *ngIf="showAddALine">
          <a [routerLink]="[contentData?.addALineLink]"
            ><i class="quick-link-icon add-line-icon"></i><span>{{ contentData?.addALine }}</span
            ><i class="fa fa-fw fa-angle-right"></i
          ></a>
        </div>
        <div class="quick-link-block">
          <a [routerLink]="['/customer-activity-log']"
            ><i class="quick-link-icon activity-log-icon"></i
            ><span>{{ contentData?.viewActivityLog }}</span
            ><i class="fa fa-fw fa-angle-right"></i
          ></a>
        </div>
      </div>
    </ng-container>
    <ng-template #notAccountLandingEnhancements>
      <div id="A" class="button-box small">
        <a
          id="view-payment"
          *ngIf="!billingPage && !isP10MCustomer"
          [routerLink]="[billingLandingConstants.BILLING_LANDING_URL]"
          ><span class="center"
            ><i class="fa fa-dollar"></i>{{ contentData?.viewPaymentSummary }}</span
          ></a
        >
        <a
          id="redeem-card"
          (click)="openDisclaimerModal($event, billingConstants.REDEEM_CARD)"
          *ngIf="billingPage && !isP10MCustomer"
          href="javascript:void(0)"
          [class.disabled]="isTouristPlan"
          ><span class="center"
            ><em class="fa fa-credit-card"></em>{{ contentData?.redeemCard }}</span
          ></a
        >
        <a id="view-usage" *ngIf="isP10MCustomer" [routerLink]="['/usage-details']"
          ><span class="center"
            ><i class="fa fa-bar-chart"></i>{{ contentData?.yourUsage }}</span
          ></a
        >
      </div>
      <div id="B" class="button-box small">
        <a
          id="activity-log"
          *ngIf="isP10MCustomer || !billingPage"
          [routerLink]="['/customer-activity-log']"
          ><span class="center"
            ><i class="fa fa-list"></i>{{ contentData?.viewActivityLog }}</span
          ></a
        >
        <a
          id="auto-pay"
          *ngIf="billingPage && !isP10MCustomer"
          (click)="openDisclaimerModal($event, billingConstants.AUTO_PAY)"
          tmoUIPermission
          [targetName]="permissionConstants.CREATE_AUTOPAY"
          [class.disabled]="isTouristPlan || isBlackout"
          ><span class="center"
            ><em class="t-icon t-icon-share-set-autopay"></em>
            <i class="t-icon t-icon-share-set-autopay-magenta hover"></i
            >{{ contentData?.setAutoPay }}</span
          ></a
        >
      </div>
    </ng-template>
  </div>
</div>
<!-- Run Payment Disclaimer Modal -->
<tmo-payment-disclaimer-modal
  #paymentDisclaimerModal
  id="payment-disclaimer-modal"
  [routeId]="routeId"
  [isCancelledAccount]="isCancelledAccount"
  [isAccountClosed]="isAccountClosed"
  [configurableAemData]="contentData"
  [modalHeading]="modalHeading"
  [modalText]="modalText"
></tmo-payment-disclaimer-modal>
<div
  *ngIf="!accountBillingTypePrepaid && !isP10MCustomer"
  class="row"
  [ngClass]="billingPage ? 'summary-panel' : ''"
>
  <div class="col-12 col-md-9 tertiary-vertical-content bg-gray-lighter">
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-7 col-lg-7">
        <div class="m-t-xl clearfix">
          <p class="lead">
            {{ contentData?.currentBalance
            }}<span class="pull-right">{{
              customerAccountBillingDetails?.balanceDue | currency: 'USD' : 'symbol-narrow'
            }}</span>
          </p>
          <p class="xsmall m-t-xs">{{ contentData?.currentServiceBalanceInfo }}</p>
          <p class="lead m-t-sm">
            {{ contentData?.dueDate
            }}<span class="pull-right">{{ customerAccountBillingDetails?.dueDate }}</span>
          </p>
          <p class="xsmall m-t-xs">{{ dueDateText }}</p>
          <p
            class="lead m-t-sm"
            *ngIf="customerAccountBillingDetails?.pastDueAmount && showPastDueAmount"
          >
            {{ contentData?.pastDueAmount }}
            <span class="pull-right">{{
              customerAccountBillingDetails?.pastDueAmount | currency: 'USD' : 'symbol-narrow'
            }}</span>
          </p>
          <p
            class="xsmall m-t-xs"
            *ngIf="customerAccountBillingDetails?.postpaid?.pastDueAmount && showPastDueAmount"
          >
            {{ latePaymentInfo }}
          </p>
          <p class="lead m-t-sm">
            {{ contentData?.billCloseDate
            }}<span class="pull-right">{{ customerAccountBillingDetails?.billCycleEndDate }}</span>
          </p>
          <p class="xsmall m-t-xs">{{ contentData?.billCycleClose }}</p>
          <p class="lead m-t-sm">
            {{ contentData?.autopay
            }}<span class="pull-right">{{
              customerAccountBillingDetails?.autoPay
                ? contentData?.enrolled
                : contentData?.notEnrolled
            }}</span>
          </p>
          <p class="text-magenta m-t-xs xsmall">
            <a href="javascript:void(0)" [class.disabled]="isTouristPlan" id="cta-default-21">{{
              contentData?.manageAutopay
            }}</a>
          </p>
        </div>
        <p
          class="lead m-t-md"
          *ngIf="
            customerAccountBillingDetails?.postpaid?.eipPlanInfo?.equipmentCreditLineBalance &&
            showEipBalance
          "
        >
          {{ contentData?.eipBalance
          }}<span class="pull-right">{{
            customerAccountBillingDetails?.postpaid?.eipPlanInfo.equipmentCreditLineBalance
              | currency: 'USD' : 'symbol-narrow'
          }}</span>
        </p>
        <p
          class="xsmall m-t-xs"
          *ngIf="
            customerAccountBillingDetails?.postpaid?.eipPlanInfo?.equipmentCreditLineBalance &&
            showEipBalance
          "
        >
          {{ contentData?.eipDueInfo }}
        </p>
        <div class="text-center m-t-xl m-b-xl">
          <button id="make-payment" class="btn btn-primary">{{ contentData?.makePayment }}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3 tertiary-buttons-vertical buttons-2">
    <div class="button-box small">
      <a
        id="view-payment-summary"
        *ngIf="!billingPage"
        [routerLink]="[billingLandingConstants.BILLING_LANDING_URL]"
        ><span class="center"
          ><i class="fa fa-dollar"></i>{{ contentData?.viewPaymentSummary }}</span
        ></a
      >
      <a
        id="eip-installment"
        *ngIf="billingPage"
        [class.anchr-disabled]="true"
        href="#"
        class="disabled"
        ><span class="center"
          ><i class="fa fa-dollar"></i><br />{{ contentData?.eipInstallmentPlan }}</span
        ></a
      >
    </div>
    <div class="button-box small">
      <!-- TODO will fix tabindex once disabled will be conditional-->
      <a
        id="view-activity-log"
        *ngIf="!billingPage"
        tabindex="-1"
        [routerLink]="[billingLandingConstants.CUSTOMER_ACTIVITY_LOG_URL]"
        ><span class="center"><i class="fa fa-list"></i>{{ contentData?.viewActivityLog }}</span></a
      >
      <a
        id="set-autopay"
        *ngIf="billingPage"
        [class.disabled]="isBlackout"
        [routerLink]="[billingLandingConstants.AUTOPAY_URL]"
        tmoUIPermission
        [targetName]="permissionConstants.CREATE_AUTOPAY"
        ><span class="center"
          ><i class="t-icon t-icon-share-set-autopay"></i
          ><i class="t-icon t-icon-share-set-autopay-magenta hover"></i><br />{{
            contentData?.setAutoPay
          }}</span
        ></a
      >
    </div>
  </div>
</div>
